import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';

/**
 * Reusable confirmation dialog for destructive or important actions.
 */
export default function ConfirmDialog({ open, onConfirm, onCancel, onClose, title, description, extra, confirmLabel = 'Confirm', cancelLabel = 'Cancel', variant = 'default' }) {
  // iter_181 — accept onClose as an alias so a prop-name mismatch can never
  // produce an undismissable "trap" dialog again (DraftRoom hit this).
  const cancel = onCancel || onClose;
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) cancel?.(); }}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
          {/* 2026-09-03 — optional block content (e.g. <FeeWarning/>) rendered
              OUTSIDE the <p> description so block elements stay valid HTML. */}
          {extra}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={cancel} data-testid="confirm-dialog-cancel">{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="confirm-dialog-confirm" className={variant === 'destructive' ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90' : ''}>
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
